/**
 * Minimal Footer
 * 
 * Just copyright and essential links.
 * Maximum content focus.
 */

import { Link } from "react-router-dom";
import { siteConfig } from "@/lib/site-config";

const FooterMinimal = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-background border-t border-border py-6">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col sm:flex-row items-center justify-between gap-4 text-sm text-muted-foreground">
          {/* Copyright */}
          <span>
            © {currentYear} {siteConfig.organizationName}
          </span>

          {/* Essential Links */}
          <div className="flex items-center gap-4">
            <Link to="/privacy" className="hover:text-foreground transition-colors">
              Privacy
            </Link>
            <span className="text-border">•</span>
            <Link to="/accessibility" className="hover:text-foreground transition-colors">
              Accessibility
            </Link>
            <span className="text-border">•</span>
            <Link to="/contact" className="hover:text-foreground transition-colors">
              Contact
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default FooterMinimal;





